import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d982e06e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {color: ' #ffffff'},
  class: "text-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-10 px-10 pb-10 py-10 flex justify-center align-middle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: 500,
    height: 500,
    src: _imports_0
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Please Connect Wallet", -1))
const _hoisted_4 = {
  key: 1,
  style: {color: ' #ffffff'}
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  style: {color: ' #ffffff'}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full text-center mb-5" }, " Farmer account not found, Create a new one? ", -1))
const _hoisted_8 = { class: "w-full text-center" }
const _hoisted_9 = { class: "processing" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigPane = _resolveComponent("ConfigPane")!
  const _component_FarmerDisplay2 = _resolveComponent("FarmerDisplay2")!
  const _component_Vault2 = _resolveComponent("Vault2")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.wallet)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(_component_ConfigPane),
          _hoisted_3
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ConfigPane),
          (_ctx.farmerAcc)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_FarmerDisplay2, {
                  key: _ctx.farmerAcc,
                  farm: _ctx.farm,
                  farmAcc: _ctx.farmAcc,
                  farmer: _ctx.farmer,
                  farmerAcc: _ctx.farmerAcc,
                  class: "mb-2",
                  onRefreshFarmer: _ctx.handleRefreshFarmer
                }, null, 8, ["farm", "farmAcc", "farmer", "farmerAcc", "onRefreshFarmer"]),
                _createVNode(_component_Vault2, {
                  key: _ctx.farmerAcc,
                  class: "mb-10",
                  vault: _ctx.farmerAcc.vault.toBase58(),
                  onSelectedWalletNft: _ctx.handleNewSelectedNFT,
                  onBeginStaking: _ctx.beginStaking,
                  onCurrentVaultNfts: _ctx.currentVaultNFTs
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("button", {
                      class: "button mb-10 mr-5 ml-5",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.burnToken && _ctx.burnToken(...args)))
                    }, " Burn " + _toDisplayString(_ctx.numWATR) + " $WATR ", 513), [
                      [_vShow, _ctx.farmerState === 'unstaked' && !_ctx.showStakeBtn]
                    ]),
                    _withDirectives(_createElementVNode("button", {
                      class: "button mb-10 mr-5 ml-5",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.beginStaking && _ctx.beginStaking(...args)))
                    }, " Begin Curating ", 512), [
                      [_vShow, _ctx.farmerState === 'unstaked' && _ctx.showStakeBtn === true]
                    ]),
                    (_ctx.farmerState === 'staked' || _ctx.farmerState === 'pendingCooldown')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button mb-10 mr-5 ml-5",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.endStaking && _ctx.endStaking(...args)))
                        }, " End staking "))
                      : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("button", {
                      class: "button mb-10 mr-5 ml-5",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.claimPlants && _ctx.claimPlants(...args)))
                    }, " Claim Available Plants ", 512), [
                      [_vShow, _ctx.showGrowBtn === true]
                    ])
                  ]),
                  _: 1
                }, 8, ["vault", "onSelectedWalletNft", "onBeginStaking", "onCurrentVaultNfts"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("button", {
                    class: "button mb-10 mr-5 ml-5",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.initFarmer && _ctx.initFarmer(...args)))
                  }, " New Farmer ")
                ])
              ]))
        ])),
    _withDirectives(_createElementVNode("div", _hoisted_9, " Processing Transaction... Do not refresh page! ", 512), [
      [_vShow, _ctx.processing === true]
    ])
  ], 64))
}